import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SpinnerLoadingAyWebComponent } from "@shared-ay/spinner-loading-ay-web/spinner-loading-ay-web.component";
import { LoaderSpinnerAyModule } from "features";
import { IconModule, UiKitModule } from "@jack-sparrow-libraries/ui-kit";

@NgModule({
	declarations: [SpinnerLoadingAyWebComponent],
	imports: [CommonModule, LoaderSpinnerAyModule, UiKitModule, IconModule],
	exports: [SpinnerLoadingAyWebComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SpinnerLoadingAyWebModule {}
